/**
 * FH-A11Y batch 21 (2026-09-28)
 * 1. Product photo gallery, axe "presentation-role-conflict".
 *    The gallery slides (ul#Slider-Gallery-...) are role=presentation (ada-a11y-fixes.js Block L, because Slick
 *    wraps them so they are no longer a real list). Slick marks the slide being shown aria-hidden="false", and an
 *    ARIA attribute on a presentational element makes screen readers ignore the role, so axe flags it.
 *    "false" is the default anyway: this removes it. Hidden slides keep aria-hidden="true". Nothing visible changes.
 * 2. Pages with no level-one heading (axe "page-has-heading-one"), e.g. /pages/blog, which opens straight into
 *    the featured post: adds a hidden level-one heading with the page's name at the top of the main content.
 *    Only on /pages/... URLs, and only when the page has no level-one heading of its own. Nothing visible changes.
 * Rollback: remove the batch 21 line at the end of snippets/freshdesk.liquid.
 */
(function () {
  'use strict';
  if (window.__fhA11yBatch21) return;
  window.__fhA11yBatch21 = true;

  /* 1. Gallery */
  var SEL = 'ul[id^="Slider-Gallery"] li[aria-hidden="false"], ul.product__media-list li[aria-hidden="false"]';

  function fixGallery() {
    document.querySelectorAll(SEL).forEach(function (li) {
      if (/^(presentation|none)$/.test(li.getAttribute('role') || '')) li.removeAttribute('aria-hidden');
    });
  }

  var timer = 0;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = 0; try { fixGallery(); } catch (e) {} }, 50);
  }
  function startGallery() {
    if (!document.querySelector('ul[id^="Slider-Gallery"], ul.product__media-list')) return; /* product pages only */
    fixGallery();
    /* Slick sets aria-hidden again whenever the slide changes. */
    new MutationObserver(schedule).observe(document.documentElement, {
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden', 'role']
    });
  }

  /* 2. Level-one heading on pages that have none */
  /* A level-one heading other than ours that isn't hidden from screen readers. */
  function hasH1() {
    var list = document.querySelectorAll('h1, [role="heading"][aria-level="1"]');
    for (var i = 0; i < list.length; i++) {
      if (list[i].id !== 'fh-page-h1' && !list[i].closest('[aria-hidden="true"]')) return true;
    }
    return false;
  }
  function fixPageH1() {
    if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?pages\//i.test(location.pathname)) return;
    if (document.getElementById('fh-page-h1') || hasH1()) return;
    var main = document.getElementById('MainContent') || document.querySelector('main');
    if (!main) return;
    var name = (document.title || '').split(/\s+[–—|-]\s+/)[0].trim();
    if (!name) return;
    var h = document.createElement('h1');
    h.id = 'fh-page-h1';
    h.className = 'visually-hidden';
    h.textContent = name;
    main.insertBefore(h, main.firstChild);
  }

  function start() {
    try { startGallery(); } catch (e) {}
    try { fixPageH1(); } catch (e) {}
    /* Page builders and apps can add their own heading late: check again once everything has loaded. */
    window.addEventListener('load', function () {
      try {
        var own = document.getElementById('fh-page-h1');
        if (own && hasH1()) own.remove();
        else if (!own) fixPageH1();
      } catch (e) {}
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
